import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {PrimeReactProvider} from 'primereact/api';
import ConfigLoader from './common/components/ConfigLoader';
import './common/i18n/config';
import './styles/primereact/primereact.scss';
import './tailwind.css';
import "primeicons/primeicons.css";
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <div className="font-raleway">
    {/* TODO remove strict mode */}
    <React.StrictMode>
      <ConfigLoader>
        <PrimeReactProvider value={{unstyled: false, cssTransition: false}}>
          <App/>
        </PrimeReactProvider>
      </ConfigLoader>
    </React.StrictMode>
  </div>
);
